import React from 'react';
import {Link} from 'react-router-dom';

import './redirect-permission.css';

const RedirectPermission = () => (
    <div className='page-redirect'>
        <main className='page-main'>
            <h1 className='title'>Obrigado!</h1>

            <h4 className='text'>Sua permissão foi concedida com sucesso.</h4>
            <h4 className='text'>Agora você pode voltar para o nosso aplicativo e continuar aproveitando os novos recursos.</h4>

            <button className='btn-back-to-home'>
                <Link to='/home'>
                    Clique aqui para voltar a pagina inicial
                </Link>
            </button>
        </main>

    </div>
);

export default RedirectPermission;